import { useContext } from 'react';
import { ContainerContext } from './context/container-context.provider';

// Define a hook to access the container from within a component that in turn allows the component to access the services registered in the container
export const useContainer = () => {
  const container = useContext(ContainerContext);
  if (!container) {
    throw new Error(
      'Container not found. Make sure to wrap your components with a ContainerProvider.'
    );
  }
  return container;
};
